import { render, staticRenderFns } from "./RadioButtonList.vue?vue&type=template&id=01c218e9&scoped=true&lang=html&"
import script from "./RadioButtonList.vue?vue&type=script&lang=js&"
export * from "./RadioButtonList.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtonList.vue?vue&type=style&index=0&id=01c218e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c218e9",
  null
  
)

export default component.exports